<template>
    <div
        :class="[
            'absolute',
            'text-theme-text',
            'p-1',
            'bg-theme-bg',
            'rounded-md',
            'border',
            'border-theme-border',
            positioningSubMenu,
        ]"
    >
        <slot />
    </div>
</template>
<script>
export default {
    props: {
        submenuDisplayInDown: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    computed: {
        positioningSubMenu() {
            return this.submenuDisplayInDown ? 'top-12' : 'bottom-14';
        },
    },
};
</script>
